module.exports = __webpack_public_path__ + "media/images/custom_page/toz_event/toz-event-ja-efed6d34551551ab4ed9d7b3f9cdd33c.png";